import {useState} from "react"
import {ToggleSwitchComponent} from "../../../../basic-ui-components/form/toggle-switch/toggle-switch.component"
import {InfoBubbleTooltipComponent} from "../../../info-bubble-tooltip/info-bubble-tooltip.component"
import {ClientSettingsSectionIconBox} from "./boxes/section-icon/client-settings-section-icon.box"
import {ClientSettingsToggleBox} from "./boxes/toggle/client-settings-toggle.box"
import {ClientSettingsSectionContainerBox} from "./boxes/section-container/client-settings-section-container.box"
import {ISvgIconProps} from "../../../../basic-ui-components/icon/svg-icon/svg.icon"
import {useServices} from "../../../../react-hooks/use-services.hook"
import {CyClass} from "../../../../../common/cy-classes"
import {observer} from "mobx-react"


interface IClientSettingsToggleSectionProps {
    icon: React.ComponentType<ISvgIconProps>;
    title: string;
    infoTooltipText?: string;
    isOn: boolean;
    onToggle: (isToggleOn: boolean) => void;
}

export const ClientSettingsToggleSectionComponent = observer((props: IClientSettingsToggleSectionProps) => {
    const [isToggleOn, setIsToggleOn] = useState(props.isOn);
    const services = useServices();
    const SectionIcon = props.icon;

    const toggleTogglerState = (selectToggle: boolean) => {
        props.onToggle(selectToggle);
        setIsToggleOn(selectToggle);
        services.clientSettings.sendOrbitUserFlowAnalytics(props.title, selectToggle.toString());
    }

    return (
        <ClientSettingsSectionContainerBox>
            <ClientSettingsSectionIconBox>
                <SectionIcon />
            </ClientSettingsSectionIconBox>

            <InfoBubbleTooltipComponent
                key={props.title}
                label={props.title}
                infoBubbleContent={props.infoTooltipText && props.infoTooltipText}
                fetureName="Client settings info tooltip"
                analyticsFeatureName="Client settings info tooltip"
                styling={{fontSize: '10px', lineHeight: '14px'}}
                placement="bottom"
            />

            <ClientSettingsToggleBox checked={isToggleOn}>
                <ToggleSwitchComponent
                    checked={isToggleOn}
                    onToggle={toggleTogglerState}
                    className={CyClass('cy-client-settings-touchid-toggler')}
                />
            </ClientSettingsToggleBox>
        </ClientSettingsSectionContainerBox>
    )
})